import React from 'react'
import { color } from 'ui/src/styles/index'

interface IProps {
  isActive: boolean
  type: string
  width?: string
  height?: string
}

function CustomisedDrinkIcons({ isActive, width = '56', height = '56', type }: IProps) {
  switch (type.toLocaleLowerCase()) {
    case 'size_small':
    case 'size_single':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3336)">
            <path
              d="M39.6184 24.2627L37.8217 17.5893C37.6817 17.0993 37.2384 16.7493 36.7017 16.7493H33.6451L33.1084 14.7893C32.9684 14.2993 32.5251 13.9727 31.9884 13.9727H21.6751C21.1617 13.9727 20.6951 14.2993 20.5551 14.7893L20.2284 15.9093C20.0884 16.3993 19.6451 16.726 19.1084 16.726H17.0084C16.4951 16.726 16.0284 17.0527 15.8884 17.5427L14.0451 24.2627C13.8584 24.9627 14.3951 25.6627 15.1651 25.6627H38.5217C39.2684 25.6627 39.8284 24.986 39.6417 24.2627H39.6184Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M36.7723 28H16.8923C16.169 28 15.6323 28.6533 15.7723 29.3767L20.229 50.3767C20.3223 50.9367 20.8123 51.3333 21.349 51.3333H32.3156C32.8756 51.3333 33.3423 50.9367 33.4356 50.3767L37.8923 29.3767C38.009 28.6533 37.4723 28 36.7723 28Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3336">
              <rect width="25.6667" height="37.3333" fill="white" transform="translate(14 14)" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'size_medium':
    case 'size_double':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3340)">
            <path
              d="M41.9518 20.112L40.1551 13.112C40.0151 12.5987 39.5718 12.2487 39.0351 12.2487H36.0018L35.4651 10.1954C35.3251 9.68203 34.8818 9.33203 34.3685 9.33203H21.6051C21.0918 9.33203 20.6251 9.68203 20.5085 10.1954L20.2051 11.3854C20.0651 11.8987 19.6218 12.2487 19.1085 12.2487H17.0085C16.4951 12.2487 16.0285 12.5987 15.9118 13.112L14.0451 20.112C13.8585 20.8587 14.3951 21.582 15.1418 21.582H40.8551C41.6018 21.582 42.1618 20.8587 41.9751 20.112H41.9518Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M38.2685 23.918H17.7352C17.0119 23.918 16.4519 24.5713 16.5919 25.2946L21.1185 50.378C21.2119 50.938 21.7019 51.3346 22.2619 51.3346H33.7419C34.3019 51.3346 34.7919 50.938 34.8852 50.378L39.4119 25.2946C39.5286 24.5713 38.9919 23.918 38.2685 23.918Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3340">
              <rect width="28" height="42" fill="white" transform="translate(14 9.33203)" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'size_large':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3344)">
            <path
              d="M42.4191 17.198L40.2258 9.0313C40.0858 8.51797 39.6191 8.16797 39.1058 8.16797H37.2858C36.7491 8.16797 36.3058 7.81797 36.1658 7.30464L35.6991 5.5313C35.5591 5.01797 35.0925 4.66797 34.5791 4.66797H19.5525C19.0158 4.66797 18.5725 5.01797 18.4325 5.5313L17.9658 7.30464C17.8258 7.81797 17.3591 8.16797 16.8458 8.16797H15.0258C14.4891 8.16797 14.0458 8.51797 13.9058 9.0313L11.7125 17.198C11.5025 17.9446 12.0625 18.668 12.8325 18.668H41.2991C42.0691 18.668 42.6291 17.9446 42.4191 17.198Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M38.4964 21H15.6297C14.9064 21 14.3464 21.6533 14.4864 22.3767L19.4097 50.3767C19.5031 50.9367 19.9931 51.3333 20.5531 51.3333H33.5497C34.1097 51.3333 34.5997 50.9367 34.6931 50.3767L39.6164 22.3767C39.7331 21.6533 39.1964 21 38.4731 21H38.4964Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3344">
              <rect
                width="30.8"
                height="46.6667"
                fill="white"
                transform="translate(11.668 4.66797)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'milk_whole':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3258)">
            <path
              d="M38.4987 23.332H17.4987C16.8544 23.332 16.332 23.8544 16.332 24.4987V50.1654C16.332 50.8097 16.8544 51.332 17.4987 51.332H38.4987C39.143 51.332 39.6654 50.8097 39.6654 50.1654V24.4987C39.6654 23.8544 39.143 23.332 38.4987 23.332Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M17.852 21.0013H38.152C38.922 21.0013 39.482 20.278 39.272 19.5313L37.4053 12.5313C37.2653 12.018 36.7987 11.668 36.2853 11.668H19.742C19.2053 11.668 18.762 12.018 18.622 12.5313L16.732 19.5313C16.522 20.278 17.082 21.0013 17.852 21.0013Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M36.0054 4.66797H19.9987C19.3544 4.66797 18.832 5.1903 18.832 5.83464V8.16797C18.832 8.8123 19.3544 9.33464 19.9987 9.33464H36.0054C36.6497 9.33464 37.172 8.8123 37.172 8.16797V5.83464C37.172 5.1903 36.6497 4.66797 36.0054 4.66797Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3258">
              <rect
                width="23.3333"
                height="46.6667"
                fill="white"
                transform="translate(16.332 4.66797)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'milk_skimmed':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3304)">
            <path
              d="M30.4487 23.332L16.332 37.4487V40.7387L33.7387 23.332H30.4487Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M38.4987 23.328H37.052L16.332 44.048V47.338L39.5954 24.0747C39.432 23.6314 39.012 23.3047 38.4987 23.3047V23.328Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M38.502 51.3366C39.1553 51.3366 39.6686 50.8233 39.6686 50.1699V47.1133L35.4453 51.3366H38.502Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M23.8454 23.332L16.332 30.8454V34.1587L27.1587 23.332H23.8454Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M17.4987 23.332C16.8454 23.332 16.332 23.8454 16.332 24.4987V27.5554L20.5554 23.332H17.4987Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M39.6696 27.3242L16.4062 50.5642C16.5696 51.0076 16.9896 51.3342 17.5029 51.3342H18.9496L39.6696 30.6142V27.3242Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M39.6665 40.5039L28.8398 51.3306H32.1532L39.6665 43.8172V40.5039Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M39.6645 33.9258L22.2578 51.3324H25.5478L39.6645 37.2158V33.9258Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M36.0054 4.66797H19.9987C19.3454 4.66797 18.832 5.1813 18.832 5.83464V8.16797C18.832 8.8213 19.3454 9.33464 19.9987 9.33464H36.0054C36.6587 9.33464 37.172 8.8213 37.172 8.16797V5.83464C37.172 5.1813 36.6587 4.66797 36.0054 4.66797Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M39.272 19.5273L38.8987 18.174L38.1987 15.5606L37.4987 12.9473L37.382 12.504C37.242 11.9906 36.7753 11.6406 36.262 11.6406H19.742C19.2053 11.6406 18.762 11.9906 18.622 12.504L16.732 19.5273C16.522 20.274 17.082 20.9973 17.852 20.9973H38.152C38.922 20.9973 39.482 20.274 39.272 19.5273Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3304">
              <rect
                width="23.3333"
                height="46.6667"
                fill="white"
                transform="translate(16.332 4.66797)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'milk_semi-skimmed':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3245)">
            <path
              d="M17.852 21.0013H38.152C38.922 21.0013 39.482 20.278 39.272 19.5313L37.4053 12.5313C37.2653 12.018 36.7987 11.668 36.2853 11.668H19.742C19.2053 11.668 18.762 12.018 18.622 12.5313L16.732 19.5313C16.522 20.278 17.082 21.0013 17.852 21.0013Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M36.0054 4.66797H19.9987C19.3544 4.66797 18.832 5.1903 18.832 5.83464V8.16797C18.832 8.8123 19.3544 9.33464 19.9987 9.33464H36.0054C36.6497 9.33464 37.172 8.8123 37.172 8.16797V5.83464C37.172 5.1903 36.6497 4.66797 36.0054 4.66797Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M39.6654 27.7654V24.4987C39.6654 23.8454 39.152 23.332 38.4987 23.332H17.4987C16.8454 23.332 16.332 23.8454 16.332 24.4987V24.6387C16.682 24.592 17.032 24.6854 17.2887 24.942C17.7554 25.4087 17.7554 26.132 17.2887 26.5754C17.032 26.8554 16.682 26.9487 16.332 26.902V31.242C16.6587 31.2187 16.9854 31.312 17.242 31.5687C17.7087 32.0354 17.7087 32.7587 17.242 33.202C16.9854 33.4587 16.6587 33.5754 16.332 33.552V37.892C16.6354 37.892 16.962 37.9854 17.1954 38.2187C17.662 38.6854 17.662 39.4087 17.1954 39.852C16.962 40.1087 16.6587 40.202 16.332 40.202V44.5187C16.6354 44.5187 16.9154 44.6354 17.1487 44.8454C17.6154 45.312 17.6154 46.0354 17.1487 46.4787C16.9154 46.712 16.6354 46.8287 16.332 46.8287V50.1187C16.332 50.772 16.8454 51.2854 17.4987 51.2854H38.4987C39.152 51.2854 39.6654 50.772 39.6654 50.1187V49.9787C39.3387 50.002 38.9887 49.9087 38.732 49.652C38.2654 49.1854 38.2654 48.462 38.732 47.9954C38.9887 47.7387 39.3387 47.6454 39.6654 47.6687V43.3287C39.3387 43.3287 39.012 43.2354 38.7787 43.002C38.312 42.5354 38.312 41.812 38.7787 41.3454C39.012 41.112 39.3387 40.9954 39.6654 41.0187V36.702C39.362 36.702 39.0587 36.6087 38.8254 36.3754C38.3587 35.9087 38.3587 35.1854 38.8254 34.7187C39.0587 34.4854 39.362 34.3687 39.6654 34.3687V30.052C39.3854 30.052 39.082 29.9354 38.872 29.7254C38.4054 29.2587 38.4054 28.5354 38.872 28.0687C39.082 27.8587 39.3854 27.742 39.6654 27.7187V27.7654ZM20.462 49.8154C19.9954 50.282 19.272 50.282 18.8054 49.8154C18.3387 49.3487 18.3387 48.6254 18.8054 48.1587C19.272 47.692 20.0187 47.692 20.462 48.1587C20.9287 48.6254 20.9287 49.3487 20.462 49.792V49.8154ZM20.5087 43.1654C20.042 43.632 19.3187 43.632 18.852 43.1654C18.3854 42.6987 18.3854 41.9754 18.852 41.5087C19.3187 41.042 20.0654 41.042 20.5087 41.5087C20.952 41.9754 20.9754 42.6987 20.5087 43.142V43.1654ZM20.5554 36.5387C20.0887 37.0054 19.3654 37.0054 18.8987 36.5387C18.432 36.072 18.432 35.3487 18.8987 34.882C19.3654 34.4154 20.112 34.4154 20.5554 34.882C21.022 35.3487 21.022 36.072 20.5554 36.5154V36.5387ZM20.602 29.8887C20.1354 30.3554 19.412 30.3554 18.9454 29.8887C18.4787 29.422 18.4787 28.6987 18.9454 28.232C19.412 27.7654 20.1587 27.7654 20.602 28.232C21.0687 28.6987 21.0687 29.422 20.602 29.8654V29.8887ZM23.7987 46.4787C23.332 46.9454 22.6087 46.9454 22.142 46.4787C21.6754 46.012 21.6754 45.2887 22.142 44.822C22.6087 44.3554 23.3554 44.3554 23.7987 44.822C24.242 45.2887 24.2654 46.012 23.7987 46.4554V46.4787ZM23.8454 39.8287C23.3787 40.2954 22.6554 40.2954 22.1887 39.8287C21.722 39.362 21.722 38.6387 22.1887 38.172C22.6554 37.7054 23.402 37.7054 23.8454 38.172C24.312 38.6387 24.312 39.362 23.8454 39.8054V39.8287ZM23.892 33.1787C23.4254 33.6454 22.702 33.6454 22.2354 33.1787C21.7687 32.712 21.7687 31.9887 22.2354 31.522C22.702 31.0554 23.4487 31.0554 23.892 31.522C24.3587 31.9887 24.3587 32.712 23.892 33.1554V33.1787ZM23.9387 26.5287C23.472 26.9954 22.7487 26.9954 22.282 26.5287C21.8154 26.062 21.8154 25.3387 22.282 24.872C22.7487 24.4054 23.4954 24.4054 23.9387 24.872C24.4054 25.3387 24.4054 26.062 23.9387 26.5054V26.5287ZM27.112 49.7687C26.6454 50.2354 25.922 50.2354 25.4554 49.7687C24.9887 49.302 24.9887 48.5787 25.4554 48.112C25.922 47.6454 26.6687 47.6454 27.112 48.112C27.5554 48.5787 27.5787 49.302 27.112 49.7454V49.7687ZM27.1587 43.1187C26.692 43.5854 25.9687 43.5854 25.502 43.1187C25.0354 42.652 25.0354 41.9287 25.502 41.462C25.9687 40.9954 26.7154 40.9954 27.1587 41.462C27.6254 41.9287 27.6254 42.652 27.1587 43.0954V43.1187ZM27.2054 36.492C26.7387 36.9587 26.0154 36.9587 25.5487 36.492C25.082 36.0254 25.082 35.302 25.5487 34.8354C26.0154 34.3687 26.762 34.3687 27.2054 34.8354C27.672 35.302 27.672 36.0254 27.2054 36.4687V36.492ZM27.252 29.842C26.7854 30.3087 26.062 30.3087 25.5954 29.842C25.1287 29.3754 25.1287 28.652 25.5954 28.1854C26.062 27.7187 26.8087 27.7187 27.252 28.1854C27.7187 28.652 27.7187 29.3754 27.252 29.8187V29.842ZM30.4487 46.432C29.982 46.8987 29.2587 46.8987 28.792 46.432C28.3254 45.9654 28.3254 45.242 28.792 44.7754C29.2587 44.3087 30.0054 44.3087 30.4487 44.7754C30.892 45.242 30.9154 45.9654 30.4487 46.4087V46.432ZM30.4954 39.782C30.0287 40.2487 29.3054 40.2487 28.8387 39.782C28.372 39.3154 28.372 38.592 28.8387 38.1254C29.3054 37.6587 30.052 37.6587 30.4954 38.1254C30.962 38.592 30.962 39.3154 30.4954 39.7587V39.782ZM30.542 33.132C30.0754 33.5987 29.352 33.5987 28.8854 33.132C28.4187 32.6654 28.4187 31.942 28.8854 31.4754C29.352 31.0087 30.0987 31.0087 30.542 31.4754C31.0087 31.942 31.0087 32.6654 30.542 33.1087V33.132ZM30.5887 26.482C30.122 26.9487 29.3987 26.9487 28.932 26.482C28.4654 26.0154 28.4654 25.292 28.932 24.8254C29.3987 24.3587 30.1454 24.3587 30.5887 24.8254C31.0554 25.292 31.0554 26.0154 30.5887 26.4587V26.482ZM33.7387 49.722C33.272 50.1887 32.5487 50.1887 32.082 49.722C31.6154 49.2554 31.6154 48.532 32.082 48.0654C32.5487 47.5987 33.2954 47.5987 33.7387 48.0654C34.2054 48.532 34.2054 49.2554 33.7387 49.6987V49.722ZM33.7854 43.072C33.3187 43.5387 32.5954 43.5387 32.1287 43.072C31.662 42.6054 31.662 41.882 32.1287 41.4154C32.5954 40.9487 33.342 40.9487 33.7854 41.4154C34.252 41.882 34.252 42.6054 33.7854 43.0487V43.072ZM33.832 36.4454C33.3654 36.912 32.642 36.912 32.1754 36.4454C31.7087 35.9787 31.7087 35.2554 32.1754 34.7887C32.642 34.322 33.3887 34.322 33.832 34.7887C34.2754 35.2554 34.2987 35.9787 33.832 36.422V36.4454ZM33.8787 29.7954C33.412 30.262 32.6887 30.262 32.222 29.7954C31.7554 29.3287 31.7554 28.6054 32.222 28.1387C32.6887 27.672 33.4354 27.672 33.8787 28.1387C34.3454 28.6054 34.3454 29.3287 33.8787 29.772V29.7954ZM37.0987 46.3854C36.632 46.852 35.9087 46.852 35.442 46.3854C34.9754 45.9187 34.9754 45.1954 35.442 44.7287C35.9087 44.262 36.6554 44.262 37.0987 44.7287C37.5654 45.1954 37.5654 45.9187 37.0987 46.362V46.3854ZM37.1454 39.7354C36.6787 40.202 35.9554 40.202 35.4887 39.7354C35.022 39.2687 35.022 38.5454 35.4887 38.0787C35.9554 37.612 36.702 37.612 37.1454 38.0787C37.612 38.5454 37.612 39.2687 37.1454 39.712V39.7354ZM37.192 33.0854C36.7254 33.552 36.002 33.552 35.5354 33.0854C35.0687 32.6187 35.0687 31.8954 35.5354 31.4287C36.002 30.962 36.7487 30.962 37.192 31.4287C37.6587 31.8954 37.6587 32.6187 37.192 33.062V33.0854ZM37.2387 26.4354C36.772 26.902 36.0487 26.902 35.582 26.4354C35.1154 25.9687 35.1154 25.2454 35.582 24.7787C36.0487 24.312 36.7954 24.312 37.2387 24.7787C37.7054 25.2454 37.7054 25.9687 37.2387 26.412V26.4354Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3245">
              <rect
                width="23.3333"
                height="46.6667"
                fill="white"
                transform="translate(16.332 4.66797)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'milk_coconut':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3274)">
            <path
              d="M16.9143 22.47C19.5977 23.38 23.3077 23.9167 27.4143 23.9167C31.521 23.9167 35.231 23.3567 37.9143 22.47C40.5977 21.5833 42.231 20.3233 42.231 18.97C42.231 16.24 35.6043 14 27.4143 14C19.2243 14 12.5977 16.2167 12.5977 18.97C12.5977 20.3467 14.2543 21.5833 16.9143 22.47ZM27.4143 16.4267C33.6443 16.4267 38.7077 17.5467 38.7077 18.9467C38.7077 19.6467 37.4477 20.2767 35.4177 20.72C33.3643 21.1867 30.541 21.4667 27.4143 21.4667C24.2877 21.4667 21.4643 21.1867 19.411 20.72C17.381 20.2533 16.121 19.6233 16.121 18.9467C16.121 17.5467 21.1843 16.4267 27.4143 16.4267Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M37.778 24.9449C37.3113 25.0849 36.9613 25.4583 36.868 25.9249L36.0513 30.4283L32.878 26.4849C32.6213 26.1583 32.2246 25.9949 31.8046 26.0416C30.358 26.1816 28.888 26.2516 27.418 26.2516C21.048 26.2516 14.6313 24.9916 11.668 22.2616V27.6983C11.668 36.3783 18.318 43.9383 26.928 44.1949C35.8413 44.4749 43.168 37.2649 43.168 28.3516V22.2383C41.908 23.4049 40.018 24.2683 37.778 24.9216V24.9449Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3274">
              <rect width="31.5" height="30.1933" fill="white" transform="translate(11.668 14)" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'milk_soya':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3263)">
            <path
              d="M19.0122 19.0122C18.2422 19.7822 18.5689 21.3922 19.7122 22.5356C20.8556 23.6789 22.4656 24.0056 23.2356 23.2356C24.0056 22.4656 23.6789 20.8556 22.5356 19.7122C21.3922 18.5689 19.7822 18.2422 19.0122 19.0122Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M38.7557 19.0172C30.9624 11.2239 20.229 9.3339 14.769 14.7706C9.30903 20.2072 11.2224 30.9639 19.0157 38.7572C26.809 46.5506 37.5424 48.4406 42.979 42.9806C48.439 37.5206 46.5257 26.8106 38.7557 19.0172ZM24.639 24.6406C23.0757 26.2039 20.229 25.8772 18.2924 23.9406C16.3557 22.0039 16.029 19.1572 17.5924 17.5939C19.1557 16.0306 22.0024 16.3572 23.939 18.2939C25.8757 20.2306 26.2024 23.0772 24.639 24.6406Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3263">
              <rect
                width="34.4167"
                height="34.4167"
                fill="white"
                transform="translate(11.668 11.668)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'milk_almond':
      return ''
    case 'milk_lacto_free':
      return ''
    case 'milk_oat':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3271)">
            <path
              d="M45.0365 43.403L40.8132 39.1797C40.8132 39.1797 40.9532 39.1097 41.0232 39.063C42.4699 37.8264 45.0832 35.1664 45.2232 31.9697C45.3399 28.7964 42.9132 26.323 41.5599 25.1797C41.0465 24.7597 40.2765 24.783 39.7399 25.2497C38.2932 26.4864 35.6565 29.1464 35.5399 32.343C35.5165 32.973 35.6099 33.5564 35.7499 34.1164L31.2932 29.6597C31.2932 29.6597 31.4332 29.5897 31.5032 29.543C32.9499 28.3064 35.5632 25.6464 35.7032 22.4497C35.8199 19.2764 33.3932 16.803 32.0399 15.6597C31.5265 15.2397 30.7565 15.263 30.2199 15.7297C28.7732 16.9664 26.1365 19.6264 26.0199 22.823C25.9965 23.453 26.0899 24.0364 26.2299 24.5964L22.4265 20.793C22.5432 18.9497 22.3799 15.7997 20.3499 13.793C18.1799 11.5997 14.7265 11.5764 12.9765 11.7164C12.3232 11.7864 11.7865 12.323 11.7165 12.9764C11.5765 14.7264 11.5999 18.1797 13.7699 20.3497C15.7999 22.3797 18.9499 22.5197 20.7699 22.4264L24.5732 26.2297C24.0132 26.0897 23.4299 25.9964 22.7999 26.0197C19.6265 26.1364 16.9432 28.773 15.7065 30.2197C15.2399 30.7564 15.2165 31.5497 15.6365 32.0397C16.7565 33.393 19.2299 35.8197 22.4265 35.703C25.5999 35.5864 28.2599 32.973 29.5199 31.503C29.5665 31.433 29.6132 31.363 29.6365 31.293L34.0932 35.7497C33.5332 35.6097 32.9499 35.5164 32.3199 35.5397C29.1465 35.6564 26.4632 38.293 25.2265 39.7397C24.7599 40.2764 24.7365 41.0697 25.1565 41.5597C26.2765 42.913 28.7499 45.3397 31.9465 45.223C35.1199 45.1064 37.7799 42.493 39.0399 41.023C39.0865 40.953 39.1332 40.883 39.1565 40.813L43.3799 45.0364C43.8465 45.4797 44.5699 45.4797 45.0365 45.0364C45.5032 44.5697 45.5032 43.8464 45.0365 43.3797V43.403Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3271">
              <rect
                width="33.7167"
                height="33.7167"
                fill="white"
                transform="translate(11.668 11.668)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'coffeetype_signature':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3218)">
            <path
              d="M13.8078 20.5149C13.8078 17.7616 15.0678 14.8216 16.9811 13.6083H19.3378C17.3544 14.7983 15.7911 17.3183 15.7678 20.0483C15.7678 22.3116 16.6311 23.9449 17.4944 25.6949C19.5478 23.6649 21.8811 22.1016 24.2611 21.2149C23.6778 18.3216 23.8878 15.5216 24.9611 13.2583C24.1444 12.3716 23.1878 11.6716 22.0911 11.2516C21.2278 10.9249 20.6211 10.8083 20.0144 10.8083C19.9911 10.8083 19.9678 10.8083 19.9211 10.8083C18.2878 10.8083 18.0544 11.2983 16.6544 11.2983C16.6544 11.2983 16.6078 11.2983 16.5844 11.2983C15.0911 11.2983 14.9044 10.7616 13.1778 10.7383H13.1311C12.5478 10.7383 11.9644 10.8316 11.1011 11.1349C10.5644 11.3216 10.0511 11.6016 9.56109 11.9283C6.06109 14.2616 4.19443 19.6983 4.75443 25.3916C5.31443 31.0383 7.67109 35.8216 10.7044 38.5516C11.3111 34.7716 13.1311 30.805 15.9311 27.3516C14.9978 25.2983 13.8078 23.3149 13.8078 20.4916V20.5149Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M49.5636 16.8C47.2769 11.1533 42.7036 7 38.2702 7C37.9669 7 37.6636 7 37.3369 7.07C36.4269 7.18667 35.8202 7.39667 35.3069 7.67667C33.7902 8.49333 33.8602 9.03 32.5302 9.73C31.2236 10.43 30.8036 10.0567 29.2636 10.8733C28.7502 11.1533 28.2369 11.5267 27.6302 12.2267C27.3969 12.5067 27.2102 12.81 27.0236 13.1133C26.9069 13.3 26.7669 13.4633 26.6502 13.65C26.6036 13.7433 26.5802 13.8367 26.5336 13.9067C26.3936 14.21 26.2536 14.5367 26.1602 14.8633C25.6002 16.59 25.5302 18.5967 25.9269 20.6967C26.6502 20.5333 27.3502 20.4167 28.0502 20.37C28.2602 20.37 28.4936 20.3233 28.7269 20.3233C28.7969 20.3233 28.8669 20.3233 28.9369 20.3233C29.2402 20.3233 29.5436 20.37 29.8469 20.4167C30.1269 20.44 30.4069 20.44 30.6636 20.4867C31.3869 20.6267 32.0869 20.86 32.7169 21.14C33.6736 21.5833 34.3502 22.05 34.9802 22.68C35.7736 23.4967 36.1002 24.1033 36.3569 24.57C36.5436 24.92 36.6602 25.13 36.9869 25.4567C37.3136 25.7833 37.5236 25.9 37.8736 26.11C38.3636 26.39 38.9469 26.7167 39.7402 27.5333C40.3469 28.1633 40.8136 28.8633 41.2336 29.82C42.1436 31.85 42.1669 34.23 41.5136 36.6567C41.5836 36.6567 41.6536 36.68 41.7236 36.7033C42.1669 36.75 42.5869 36.7967 43.0069 36.7967C44.2902 36.7967 45.5036 36.54 46.5536 35.98C51.3369 33.4367 52.8536 24.99 49.5402 16.7767L49.5636 16.8ZM45.0836 33.53L42.8436 34.72C44.1969 32.2233 44.0336 29.75 42.7736 27.44C40.7669 23.8 36.7769 23.2867 34.5136 19.1567C33.1836 16.73 32.8802 13.5567 33.9769 11.5733L36.0536 10.4767C34.8636 12.4367 34.7236 15.4233 36.0069 17.8267C38.1069 21.77 42.1202 21.84 44.5936 26.46C45.9702 29.0267 45.9702 31.8967 45.1069 33.5533L45.0836 33.53Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M38.496 28.7979C37.2827 27.5613 36.7693 27.7946 35.7427 26.7212C34.6927 25.6712 34.926 25.1579 33.7127 23.9212C33.2927 23.5012 32.8027 23.1279 31.9627 22.7312C31.4493 22.4746 30.8893 22.3113 30.306 22.1946C30.1893 22.1946 30.0727 22.1946 29.956 22.1712C29.676 22.1246 29.3727 22.1012 29.0927 22.0779C28.976 22.0779 28.836 22.0312 28.7193 22.0312C28.556 22.0312 28.3927 22.0546 28.2293 22.0779C27.5993 22.1012 26.9693 22.1946 26.3393 22.3579C26.0593 22.4279 25.7793 22.4979 25.4993 22.5679C25.2193 22.6613 24.9393 22.7546 24.6593 22.8713C22.046 23.8979 19.456 25.7879 17.356 28.3313C14.346 31.9946 12.6427 36.1013 12.2693 39.7413C12.246 40.0913 12.246 40.4179 12.2227 40.7446C12.2227 41.0713 12.2227 41.3979 12.2227 41.7246C12.2227 42.2146 12.2693 42.6812 12.3393 43.1246C12.6193 44.8979 13.296 46.4146 14.416 47.5579C15.956 49.1446 18.3127 49.9146 20.996 49.9146C24.916 49.9146 29.5827 48.2579 33.7127 45.0146C36.256 43.0079 38.1927 40.5113 39.2893 37.9679C39.406 37.6879 39.476 37.4313 39.5693 37.1513C39.6627 36.8713 39.756 36.5913 39.8493 36.3346C40.4093 34.3046 40.4093 32.2979 39.6393 30.5713C39.266 29.7313 38.8927 29.2179 38.496 28.7979ZM28.906 32.3213C25.7093 35.4479 26.7593 39.3212 23.026 42.9612C20.9493 44.9912 18.196 45.8079 16.3527 45.4579L14.5793 43.6379C17.356 44.2446 19.7127 43.3813 21.556 41.5146C24.496 38.5746 23.866 34.5846 27.2027 31.2712C29.1627 29.3112 32.126 28.1213 34.3427 28.6113L35.9993 30.2912C33.7827 29.7079 30.866 30.4079 28.9293 32.2979L28.906 32.3213Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3218">
              <rect
                width="46.6667"
                height="42.9333"
                fill="white"
                transform="translate(4.66797 7)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'coffeetype_decaf':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3254)">
            <path
              d="M35.5136 9.96203C34.4403 9.54203 33.6936 9.42536 32.9703 9.42536C30.8469 9.42536 30.5903 10.032 28.7469 10.032C26.9036 9.98536 26.6469 9.33203 24.5236 9.33203C23.8003 9.33203 23.0303 9.42536 21.9569 9.82203C16.4269 11.8054 13.3469 19.3887 14.1169 27.392C15.1903 38.2654 21.6536 46.5954 28.3503 46.6654C35.0469 46.7354 41.6969 38.522 42.9803 27.672C43.9136 19.692 40.9736 12.0387 35.4903 9.96203H35.5136ZM39.3169 18.222C39.9469 18.292 40.4136 18.8754 40.3436 19.5054C40.2736 20.1354 39.6903 20.602 39.0603 20.532C38.4303 20.462 37.9636 19.8787 38.0336 19.2487C38.1036 18.6187 38.6869 18.152 39.3169 18.222ZM34.5803 14.8854C35.2103 14.9554 35.6769 15.5387 35.6069 16.1687C35.5369 16.7987 34.9536 17.2654 34.3236 17.1954C33.6936 17.1254 33.2269 16.542 33.2969 15.912C33.3669 15.282 33.9503 14.8154 34.5803 14.8854ZM24.7569 28.8154C25.4103 28.8154 25.9236 29.3287 25.9236 29.982C25.9236 30.6354 25.4103 31.1487 24.7569 31.1487C24.1036 31.1487 23.5903 30.6354 23.5903 29.982C23.5903 29.3287 24.1036 28.8154 24.7569 28.8154ZM26.2036 34.1587C26.8569 34.1587 27.3703 34.672 27.3703 35.3254C27.3703 35.9787 26.8569 36.492 26.2036 36.492C25.5503 36.492 25.0369 35.9787 25.0369 35.3254C25.0369 34.672 25.5503 34.1587 26.2036 34.1587ZM23.5203 19.0154C23.5203 19.6687 23.0069 20.182 22.3536 20.182C21.7003 20.182 21.1869 19.6687 21.1869 19.0154C21.1869 18.362 21.7003 17.8487 22.3536 17.8487C23.0069 17.8487 23.5203 18.362 23.5203 19.0154ZM21.7936 12.5287C22.4469 12.5287 22.9603 13.042 22.9603 13.6954C22.9603 14.3487 22.4469 14.862 21.7936 14.862C21.1403 14.862 20.6269 14.3487 20.6269 13.6954C20.6269 13.042 21.1403 12.5287 21.7936 12.5287ZM21.7936 23.4954C22.4469 23.4954 22.9603 24.0087 22.9603 24.662C22.9603 25.3154 22.4469 25.8287 21.7936 25.8287C21.1403 25.8287 20.6269 25.3154 20.6269 24.662C20.6269 24.0087 21.1403 23.4954 21.7936 23.4954ZM16.2169 21.3487C16.2169 20.6954 16.7303 20.182 17.3836 20.182C18.0369 20.182 18.5503 20.6954 18.5503 21.3487C18.5503 22.002 18.0369 22.5154 17.3836 22.5154C16.7303 22.5154 16.2169 22.002 16.2169 21.3487ZM18.3169 30.472C17.6636 30.472 17.1503 29.9587 17.1503 29.3054C17.1503 28.652 17.6636 28.1387 18.3169 28.1387C18.9703 28.1387 19.4836 28.652 19.4836 29.3054C19.4836 29.9587 18.9703 30.472 18.3169 30.472ZM20.8836 35.9554C20.2303 35.9554 19.7169 35.442 19.7169 34.7887C19.7169 34.1354 20.2303 33.622 20.8836 33.622C21.5369 33.622 22.0503 34.1354 22.0503 34.7887C22.0503 35.442 21.5369 35.9554 20.8836 35.9554ZM22.9603 42.232C22.3069 42.232 21.7936 41.7187 21.7936 41.0654C21.7936 40.412 22.3069 39.8987 22.9603 39.8987C23.6136 39.8987 24.1269 40.412 24.1269 41.0654C24.1269 41.7187 23.6136 42.232 22.9603 42.232ZM27.9069 43.282H24.7569C27.6969 41.3687 29.0036 38.5687 29.0036 35.3254C29.0036 30.192 24.9669 27.2987 24.9669 21.512C24.9669 18.1287 26.5069 14.512 28.8636 13.0187H31.7803C29.3303 14.4887 27.3936 17.592 27.3703 20.952C27.3236 26.4587 31.6169 28.8854 31.5469 35.3254C31.5003 38.9187 29.8203 41.9987 27.9069 43.282ZM31.7803 20.672C31.7103 21.302 31.1269 21.7687 30.4969 21.6987C29.8669 21.6287 29.4003 21.0454 29.4703 20.4154C29.5403 19.7854 30.1236 19.3187 30.7536 19.3887C31.3836 19.4587 31.8503 20.042 31.7803 20.672ZM30.6136 25.992C30.6836 25.362 31.2669 24.8954 31.8969 24.9654C32.5269 25.0354 32.9936 25.6187 32.9236 26.2487C32.8536 26.8787 32.2703 27.3454 31.6403 27.2754C31.0103 27.2054 30.5436 26.622 30.6136 25.992ZM33.1569 42.722C32.5269 42.652 32.0603 42.0687 32.1303 41.4387C32.2003 40.8087 32.7836 40.342 33.4136 40.412C34.0436 40.482 34.5103 41.0654 34.4403 41.6954C34.3703 42.3254 33.7869 42.792 33.1569 42.722ZM33.7636 37.122C33.1336 37.052 32.6669 36.4687 32.7369 35.8387C32.8069 35.2087 33.3903 34.742 34.0203 34.812C34.6503 34.882 35.1169 35.4654 35.0469 36.0954C34.9769 36.7254 34.3936 37.192 33.7636 37.122ZM35.5369 31.6387C34.9069 31.5687 34.4403 30.9854 34.5103 30.3554C34.5803 29.7254 35.1636 29.2587 35.7936 29.3287C36.4236 29.3987 36.8903 29.982 36.8203 30.612C36.7503 31.242 36.1669 31.7087 35.5369 31.6387ZM36.0036 24.662C35.3736 24.592 34.9069 24.0087 34.9769 23.3787C35.0469 22.7487 35.6303 22.282 36.2603 22.352C36.8903 22.422 37.3569 23.0054 37.2869 23.6354C37.2169 24.2654 36.6336 24.732 36.0036 24.662ZM38.7569 34.7887C38.1269 34.7187 37.6603 34.1354 37.7303 33.5054C37.8003 32.8754 38.3836 32.4087 39.0136 32.4787C39.6436 32.5487 40.1103 33.132 40.0403 33.762C39.9703 34.392 39.3869 34.8587 38.7569 34.7887ZM39.4803 28.1387C38.8503 28.0687 38.3836 27.4854 38.4536 26.8554C38.5236 26.2254 39.1069 25.7587 39.7369 25.8287C40.3669 25.8987 40.8336 26.482 40.7636 27.112C40.6936 27.742 40.1103 28.2087 39.4803 28.1387Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3254">
              <rect
                width="29.1667"
                height="37.3333"
                fill="white"
                transform="translate(14 9.33203)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'milk_none':
    case 'syrup_none':
    case 'extrashots_none':
    case 'extras_none':
    case 'coffeetype_none':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3333)">
            <path
              d="M42.98 17.6854C41.6967 15.8887 40.11 14.302 38.3133 13.0187C35.07 10.7087 31.1267 9.33203 26.8333 9.33203C15.89 9.33203 7 18.222 7 29.1654C7 33.4354 8.37667 37.402 10.6867 40.6454C11.97 42.442 13.5567 44.0287 15.3533 45.312C18.5967 47.622 22.54 48.9987 26.8333 48.9987C37.7767 48.9987 46.6667 40.1087 46.6667 29.1654C46.6667 24.8954 45.29 20.9287 42.98 17.6854ZM26.8333 42.3954C24.3833 42.3954 22.0967 41.7187 20.1367 40.552L38.22 22.4687C39.3867 24.4287 40.0633 26.7154 40.0633 29.1654C40.0633 36.4454 34.1367 42.3954 26.8333 42.3954ZM13.6033 29.1654C13.6033 21.8854 19.53 15.9354 26.8333 15.9354C29.2833 15.9354 31.57 16.612 33.53 17.7787L15.4467 35.862C14.28 33.902 13.6033 31.6154 13.6033 29.1654Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3333">
              <rect
                width="39.6667"
                height="39.6667"
                fill="white"
                transform="translate(7 9.33203)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'extrashots_one':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3223)">
            <path
              d="M28.8854 12.0859C28.4187 11.5026 27.5554 11.5026 27.0887 12.0859C24.3587 15.4226 16.332 25.9926 16.332 34.7893C16.332 41.3459 21.5587 46.6659 27.9987 46.6659C34.4387 46.6659 39.6654 41.3459 39.6654 34.7893C39.6654 25.9926 31.6387 15.4226 28.8854 12.0859Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3223">
              <rect width="23.3333" height="35" fill="white" transform="translate(16.332 11.668)" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'extrashots_two':
      return (
        <svg
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3267)">
            <path
              d="M33.5583 12.0859C33.0916 11.5026 32.2283 11.5026 31.7616 12.0859C30.9449 13.0893 29.6383 14.7459 28.2383 16.7993C31.5516 21.8626 35.0049 28.6059 35.0049 34.7893C35.0049 39.4326 32.7883 43.5393 29.4049 46.1293C30.4549 46.4326 31.5283 46.6659 32.6716 46.6659C39.1116 46.6659 44.3383 41.3459 44.3383 34.7893C44.3383 25.9926 36.3116 15.4226 33.5583 12.0859Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M26.832 18.948C24.8954 15.8913 22.982 13.418 21.8854 12.088C21.652 11.808 21.3254 11.668 20.9987 11.668C20.672 11.668 20.3454 11.808 20.112 12.088C17.3587 15.4246 9.33203 25.9946 9.33203 34.7913C9.33203 41.348 14.5587 46.668 20.9987 46.668C23.1454 46.668 25.1054 46.038 26.832 45.0113C30.3087 42.958 32.6654 39.1546 32.6654 34.7913C32.6654 29.4946 29.7487 23.568 26.832 18.948Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3267">
              <rect width="35" height="35" fill="white" transform="translate(9.33203 11.668)" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'extras_marshmallow':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3208)">
            <path
              d="M42.2113 20.5774C42.1413 20.1341 41.628 19.9941 41.278 20.2274C38.268 22.3508 32.7613 23.3308 27.3013 23.3308C21.8413 23.3308 16.3346 22.3508 13.3246 20.2274C12.9746 19.9708 12.4613 20.1341 12.3913 20.5774C12.018 22.7008 11.668 25.3841 11.668 27.9974C11.668 33.6908 13.3013 39.6641 13.3013 39.6641C13.3013 42.2308 19.578 44.3308 27.3246 44.3308C35.0713 44.3308 41.348 42.2541 41.348 39.6641C41.348 39.6641 42.9813 33.6908 42.9813 27.9974C42.9813 25.3608 42.6313 22.7008 42.258 20.5541L42.2113 20.5774Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M27.3046 21.0013C35.0495 21.0013 41.3279 18.912 41.3279 16.3346C41.3279 13.7573 35.0495 11.668 27.3046 11.668C19.5597 11.668 13.2812 13.7573 13.2812 16.3346C13.2812 18.912 19.5597 21.0013 27.3046 21.0013Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3208">
              <rect
                width="31.2667"
                height="32.6667"
                fill="white"
                transform="translate(11.668 11.668)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'syrup_caramel':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3291)">
            <path
              d="M41.9987 11.668H11.6654C10.382 11.668 9.33203 12.718 9.33203 14.0013V30.1246C9.33203 30.778 9.84536 31.2913 10.4987 31.2913H15.422C16.0754 31.2913 16.5887 30.778 16.5887 30.1246V26.0413C16.5887 22.8446 18.7354 19.928 21.862 19.3213C26.062 18.5046 29.772 21.7246 29.772 25.7846V34.838C29.772 36.798 31.102 38.5946 33.0387 38.9213C35.4887 39.318 37.612 37.428 37.612 35.048V28.7946C37.612 26.858 39.1754 25.2946 41.112 25.2946H43.1654C43.8187 25.2946 44.332 24.7813 44.332 24.128V14.0013C44.332 12.718 43.282 11.668 41.9987 11.668Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M42 27.6469H41.1133C40.46 27.6469 39.9467 28.1602 39.9467 28.8136V34.8336C39.9467 37.8669 37.9167 40.6436 34.93 41.2269C30.94 41.9969 27.44 38.9402 27.44 35.0902V26.0602C27.44 23.9369 25.9933 21.9536 23.8933 21.6269C21.2333 21.1836 18.9233 23.2369 18.9233 25.8269V30.1669C18.9233 32.1036 17.36 33.6669 15.4233 33.6669H11.6667C11.0133 33.6669 10.5 34.1802 10.5 34.8336V43.2102C10.5 44.4936 11.55 45.5436 12.8333 45.5436H40.8333C42.1167 45.5436 43.1667 44.4936 43.1667 43.2102V28.8602C43.1667 28.2069 42.6533 27.6936 42 27.6936V27.6469Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3291">
              <rect
                width="35"
                height="33.8333"
                fill="white"
                transform="translate(9.33203 11.668)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'syrup_hazelnut':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3250)">
            <path
              d="M26.8301 19.302C33.8301 19.302 39.5234 17.5986 39.5234 15.4986C39.5234 13.3986 33.8534 11.6953 26.8301 11.6953C19.8067 11.6953 14.1367 13.3753 14.1367 15.4753C14.1367 17.5753 19.8067 19.2786 26.8301 19.2786V19.302Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M41.4858 18.3392C41.4158 18.0592 41.0891 17.9892 40.8791 18.2225C37.5658 21.8392 26.8324 21.6058 26.8324 21.6058C26.8324 21.6058 16.0991 21.8392 12.7858 18.2225C12.5758 18.0125 12.2491 18.0592 12.1791 18.3392C11.4324 21.6758 9.2391 36.3525 26.8324 43.1658C44.4258 36.3525 42.2558 21.6758 41.4858 18.3392Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3250">
              <rect
                width="30.3333"
                height="31.5"
                fill="white"
                transform="translate(11.668 11.668)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'syrup_vanilla':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3242)">
            <path
              d="M45.4092 31.3344C44.6626 29.5611 42.4459 25.3144 37.8492 24.1711C37.0326 23.9611 36.2626 23.9144 35.4926 23.9377C35.9592 23.6344 36.4026 23.2611 36.8226 22.8411C40.1592 19.5044 39.8792 14.6977 39.5992 12.8077C39.5292 12.2944 39.1326 11.8977 38.6192 11.8277C36.7292 11.5477 31.9459 11.2677 28.5859 14.6044C28.1192 15.0711 27.7459 15.5611 27.3959 16.0744C27.0692 15.5611 26.6725 15.0711 26.2059 14.6044C22.8925 11.2444 18.1092 11.5477 16.2192 11.8277C15.7059 11.8977 15.3092 12.2944 15.2392 12.8077C14.9592 14.6977 14.6792 19.5044 18.0159 22.8411C18.4359 23.2611 18.8792 23.6344 19.3459 23.9377C18.5759 23.9377 17.8059 23.9844 16.9892 24.1711C12.3925 25.2911 10.1759 29.5611 9.42922 31.3344C9.21922 31.8011 9.35922 32.3377 9.75588 32.6644C11.2492 33.8777 15.1925 36.6077 19.7659 35.4644C20.5359 35.2777 21.2359 34.9744 21.8892 34.6244C21.7259 35.3011 21.6092 36.0244 21.6092 36.7944C21.6092 41.5311 25.2025 44.7044 26.7425 45.8477C27.1626 46.1511 27.6992 46.1511 28.1192 45.8477C29.6592 44.7044 33.2526 41.5311 33.2526 36.7944C33.2526 36.0244 33.1359 35.3011 32.9726 34.6244C33.6259 34.9744 34.3026 35.2777 35.0959 35.4644C39.6926 36.6077 43.6359 33.8777 45.1059 32.6644C45.5026 32.3377 45.6426 31.8011 45.4326 31.3344H45.4092ZM27.4192 29.4444C25.8092 29.4444 24.5025 28.1377 24.5025 26.5277C24.5025 24.9177 25.8092 23.6111 27.4192 23.6111C29.0292 23.6111 30.3359 24.9177 30.3359 26.5277C30.3359 28.1377 29.0292 29.4444 27.4192 29.4444Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3242">
              <rect
                width="36.1667"
                height="34.4167"
                fill="white"
                transform="translate(9.33203 11.668)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'syrup_sugar_free_caramel':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3322)">
            <path
              d="M48.3013 13.9514V10.0547L46.6446 11.0114L44.918 12.738V15.9114L48.3013 13.9514Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M43.7482 15.9168V13.9102L42.4648 15.1702L43.7482 15.9168Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M40.3672 13.9514L40.3905 13.9747L42.8639 11.478L40.3672 10.0547V13.9514Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M40.9531 9.02651L43.7065 10.6365L46.2031 8.16318L44.3365 7.08984L40.9531 9.02651Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M39.2 14.6287V8.70203L44.3333 5.7387L47.04 7.30203L50.0267 4.31536C48.44 3.0787 46.48 2.33203 44.3333 2.33203C39.1767 2.33203 35 6.5087 35 11.6654C35 13.812 35.77 15.772 36.9833 17.3587L39.5267 14.8154L39.2 14.6287Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M49.1367 8.51208L49.4634 8.69875V14.6254L44.3301 17.5888L41.6234 16.0254L38.6367 19.0121C40.2234 20.2488 42.1834 20.9954 44.3301 20.9954C49.4867 20.9954 53.6634 16.8188 53.6634 11.6621C53.6634 9.51542 52.8934 7.55542 51.6801 5.96875L49.1367 8.51208Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <g clipPath="url(#clip1_458_3322)">
            <path
              d="M32.6654 11.664H11.6654C10.382 11.664 9.33203 12.714 9.33203 13.9973V30.1206C9.33203 30.774 9.84536 31.2873 10.4987 31.2873H15.422C16.0754 31.2873 16.5887 30.774 16.5887 30.1206V26.0373C16.5887 22.8406 18.7354 19.924 21.862 19.3173C26.062 18.5006 29.772 21.7206 29.772 25.7806V34.834C29.772 36.794 31.102 38.5906 33.0387 38.9173C35.4887 39.314 37.612 37.424 37.612 35.044V28.7906C37.612 26.854 39.1754 25.2906 41.112 25.2906H43.1654C43.8187 25.2906 44.332 24.7773 44.332 24.124V23.3073C37.892 23.3073 32.6654 18.0806 32.6654 11.6406V11.664Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M42 27.6469H41.1133C40.46 27.6469 39.9467 28.1602 39.9467 28.8136V34.8336C39.9467 37.8669 37.9167 40.6436 34.93 41.2269C30.94 41.9969 27.44 38.9402 27.44 35.0902V26.0602C27.44 23.9369 25.9933 21.9536 23.8933 21.6269C21.2333 21.1836 18.9233 23.2369 18.9233 25.8269V30.1669C18.9233 32.1036 17.36 33.6669 15.4233 33.6669H11.6667C11.0133 33.6669 10.5 34.1802 10.5 34.8336V43.2102C10.5 44.4936 11.55 45.5436 12.8333 45.5436H40.8333C42.1167 45.5436 43.1667 44.4936 43.1667 43.2102V28.8602C43.1667 28.2069 42.6533 27.6936 42 27.6936V27.6469Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3322">
              <rect
                width="18.6667"
                height="18.6667"
                fill="white"
                transform="translate(35 2.33203)"
              />
            </clipPath>
            <clipPath id="clip1_458_3322">
              <rect
                width="35"
                height="33.8333"
                fill="white"
                transform="translate(9.33203 11.668)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'syrup_sugar_free_gingerbread':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3281)">
            <path
              d="M43.0513 23.2387C42.2113 22.3987 41.1146 21.9554 39.9246 21.9554H34.0446C35.1646 20.602 35.7713 18.8987 35.7713 17.0787C35.7713 12.8087 32.2946 9.33203 28.0013 9.33203C23.708 9.33203 20.2313 12.8087 20.2313 17.0787C20.2313 18.8987 20.838 20.602 21.958 21.9554H16.078C14.888 21.9554 13.7913 22.422 12.9513 23.2387C12.1113 24.0787 11.668 25.1754 11.668 26.3654C11.668 28.792 13.6513 30.7754 16.078 30.7754H21.188L18.2713 41.0654C18.1546 41.462 18.108 41.8587 18.108 42.2787C18.108 44.2387 19.438 45.9887 21.328 46.5254C21.7246 46.642 22.1213 46.6887 22.518 46.6887C24.4546 46.6887 26.228 45.4054 26.7646 43.492L28.0013 39.1754L29.238 43.492C29.7746 45.4287 31.5713 46.6887 33.4846 46.6887C33.8813 46.6887 34.278 46.642 34.6746 46.5254C36.5646 45.9887 37.8946 44.262 37.8946 42.2787C37.8946 41.8587 37.848 41.462 37.7313 41.0654L34.8146 30.7754H39.9246C42.3513 30.7754 44.3346 28.792 44.3346 26.3654C44.3346 25.1987 43.868 24.0787 43.0513 23.2387ZM25.0146 16.8454C24.5246 16.8454 24.128 16.4487 24.128 15.9587C24.128 15.4687 24.5246 15.072 25.0146 15.072C25.5046 15.072 25.9013 15.4687 25.9013 15.9587C25.9013 16.4487 25.5046 16.8454 25.0146 16.8454ZM28.0013 30.542C27.5113 30.542 27.1146 30.1454 27.1146 29.6554C27.1146 29.1654 27.5113 28.7687 28.0013 28.7687C28.4913 28.7687 28.888 29.1654 28.888 29.6554C28.888 30.1454 28.4913 30.542 28.0013 30.542ZM28.0013 27.322C27.348 27.322 26.8346 26.8087 26.8346 26.1554C26.8346 25.502 27.348 24.9887 28.0013 24.9887C28.6546 24.9887 29.168 25.502 29.168 26.1554C29.168 26.8087 28.6546 27.322 28.0013 27.322ZM30.008 19.3887C29.6346 19.8554 28.9113 20.3687 28.0013 20.3687C27.0913 20.3687 26.368 19.8554 25.9946 19.3887C25.7613 19.0854 25.808 18.642 26.1113 18.4087C26.4146 18.1754 26.8346 18.222 27.0913 18.5254C27.138 18.572 27.4646 18.9687 28.0013 18.992C28.538 18.992 28.8646 18.5954 28.9113 18.5254C29.1446 18.222 29.588 18.1754 29.8913 18.4087C30.1946 18.642 30.2413 19.0854 30.008 19.3887ZM30.988 16.8454C30.498 16.8454 30.1013 16.4487 30.1013 15.9587C30.1013 15.4687 30.498 15.072 30.988 15.072C31.478 15.072 31.8746 15.4687 31.8746 15.9587C31.8746 16.4487 31.478 16.8454 30.988 16.8454Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <g clipPath="url(#clip1_458_3281)">
            <path
              d="M48.3013 13.9514V10.0547L46.6446 11.0114L44.918 12.738V15.9114L48.3013 13.9514Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M43.7482 15.9168V13.9102L42.4648 15.1702L43.7482 15.9168Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M40.3672 13.9514L40.3905 13.9747L42.8639 11.478L40.3672 10.0547V13.9514Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M40.9531 9.02651L43.7065 10.6365L46.2031 8.16318L44.3365 7.08984L40.9531 9.02651Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M39.2 14.6287V8.70203L44.3333 5.7387L47.04 7.30203L50.0267 4.31536C48.44 3.0787 46.48 2.33203 44.3333 2.33203C39.1767 2.33203 35 6.5087 35 11.6654C35 13.812 35.77 15.772 36.9833 17.3587L39.5267 14.8154L39.2 14.6287Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M49.1367 8.51208L49.4634 8.69875V14.6254L44.3301 17.5888L41.6234 16.0254L38.6367 19.0121C40.2234 20.2488 42.1834 20.9954 44.3301 20.9954C49.4867 20.9954 53.6634 16.8188 53.6634 11.6621C53.6634 9.51542 52.8934 7.55542 51.6801 5.96875L49.1367 8.51208Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3281">
              <rect
                width="32.6667"
                height="37.3333"
                fill="white"
                transform="translate(11.668 9.33203)"
              />
            </clipPath>
            <clipPath id="clip1_458_3281">
              <rect
                width="18.6667"
                height="18.6667"
                fill="white"
                transform="translate(35 2.33203)"
              />
            </clipPath>
          </defs>
        </svg>
      )

    case 'syrup_sugar_free_vanilla':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3226)">
            <path
              d="M48.3013 13.9514V10.0547L46.6446 11.0114L44.918 12.738V15.9114L48.3013 13.9514Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M43.7482 15.9168V13.9102L42.4648 15.1702L43.7482 15.9168Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M40.3672 13.9514L40.3905 13.9747L42.8639 11.478L40.3672 10.0547V13.9514Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M40.9531 9.02651L43.7065 10.6365L46.2031 8.16318L44.3365 7.08984L40.9531 9.02651Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M39.2 14.6287V8.70203L44.3333 5.7387L47.04 7.30203L50.0267 4.31536C48.44 3.0787 46.48 2.33203 44.3333 2.33203C39.1767 2.33203 35 6.5087 35 11.6654C35 13.812 35.77 15.772 36.9833 17.3587L39.5267 14.8154L39.2 14.6287Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M49.1367 8.51208L49.4634 8.69875V14.6254L44.3301 17.5888L41.6234 16.0254L38.6367 19.0121C40.2234 20.2488 42.1834 20.9954 44.3301 20.9954C49.4867 20.9954 53.6634 16.8188 53.6634 11.6621C53.6634 9.51542 52.8934 7.55542 51.6801 5.96875L49.1367 8.51208Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <g clipPath="url(#clip1_458_3226)">
            <path
              d="M38.0359 21.3244C35.1892 19.2011 33.3226 15.8644 33.2992 12.0611C31.6892 12.4577 30.0326 13.1811 28.6092 14.6044C28.1426 15.0711 27.7692 15.5611 27.4192 16.0744C27.0925 15.5611 26.6959 15.0711 26.2292 14.6044C22.8925 11.2444 18.1092 11.5477 16.2192 11.8277C15.7059 11.8977 15.3092 12.2944 15.2392 12.8077C14.9592 14.6977 14.6792 19.5044 18.0159 22.8411C18.4359 23.2611 18.8792 23.6344 19.3459 23.9377C18.5759 23.9377 17.8059 23.9844 16.9892 24.1711C12.3925 25.2911 10.1759 29.5611 9.42922 31.3344C9.21922 31.8011 9.35922 32.3377 9.75588 32.6644C11.2492 33.8777 15.1925 36.6077 19.7659 35.4644C20.5359 35.2777 21.2359 34.9744 21.8892 34.6244C21.7259 35.3011 21.6092 36.0244 21.6092 36.7944C21.6092 41.5311 25.2025 44.7044 26.7425 45.8477C27.1626 46.1511 27.6992 46.1511 28.1192 45.8477C29.6592 44.7044 33.2526 41.5311 33.2526 36.7944C33.2526 36.0244 33.1359 35.3011 32.9726 34.6244C33.6259 34.9744 34.3026 35.2777 35.0959 35.4644C39.6926 36.6077 43.6359 33.8777 45.1059 32.6644C45.5026 32.3377 45.6426 31.8011 45.4326 31.3344C44.6859 29.5611 42.4692 25.3144 37.8726 24.1711C37.0559 23.9611 36.2859 23.9144 35.5159 23.9377C35.9826 23.6344 36.4259 23.2611 36.8459 22.8411C37.3126 22.3744 37.7092 21.8611 38.0359 21.3244ZM27.4192 29.4444C25.8092 29.4444 24.5025 28.1377 24.5025 26.5277C24.5025 24.9177 25.8092 23.6111 27.4192 23.6111C29.0292 23.6111 30.3359 24.9177 30.3359 26.5277C30.3359 28.1377 29.0292 29.4444 27.4192 29.4444Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3226">
              <rect
                width="18.6667"
                height="18.6667"
                fill="white"
                transform="translate(35 2.33203)"
              />
            </clipPath>
            <clipPath id="clip1_458_3226">
              <rect
                width="36.1667"
                height="34.4167"
                fill="white"
                transform="translate(9.33203 11.668)"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'syrup_sugar_free_cinnamon_bun':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.4919 32.128C24.4752 32.128 25.4103 33.0383 26.6003 34.1583C27.9067 35.4181 29.3992 36.8422 32.3151 36.8425C35.2317 36.8425 36.7256 35.4183 38.0322 34.1583L38.055 34.1811C39.245 33.0377 40.1801 32.1531 42.1634 32.1531C42.513 32.1532 42.77 32.2226 43.0498 32.2693C42.6298 36.8424 41.555 40.8324 41.555 40.8324C41.5543 43.4222 35.2317 45.5219 27.4388 45.5219C19.6461 45.5218 13.3233 43.4222 13.3226 40.8324C13.3226 40.8324 12.879 39.1989 12.459 36.8425H12.6937C15.6095 36.8422 17.1021 35.4181 18.4085 34.1583C19.575 33.0151 20.5091 32.1282 22.4919 32.128Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M12.3883 21.5824C12.4583 21.1392 12.9493 20.9751 13.3226 21.2315C16.3559 23.3782 21.9093 24.3578 27.416 24.3578C31.8906 24.3578 36.3952 23.6946 39.5544 22.307C40.5341 22.7476 41.5843 23.0583 42.6852 23.2139C42.943 25.0108 43.1432 27.0374 43.1432 29.0245V29.8197C42.8399 29.7497 42.4883 29.7491 42.1383 29.7491C39.223 29.7494 37.7298 31.1714 36.4235 32.4311C35.2335 33.5744 34.2984 34.4613 32.3151 34.4613C30.3324 34.461 29.3988 33.5509 28.209 32.4311C26.9025 31.1712 25.408 29.7491 22.4919 29.7491C19.5765 29.7494 18.0833 31.1714 16.777 32.4311C15.6105 33.5742 14.6763 34.461 12.6937 34.4613C12.437 34.4613 12.2725 34.4163 12.0625 34.393C11.8292 32.7132 11.6661 30.8693 11.666 29.0495C11.666 26.4131 12.0151 23.729 12.3883 21.5824Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M16.7998 15.6078C18.9931 18.4311 25.8293 18.6179 27.416 18.6179C28.4377 18.6179 31.6343 18.5443 34.3682 17.7361C35.0266 18.8145 35.8564 19.776 36.8177 20.5866C34.5173 21.4512 31.1584 22.0017 27.416 22.0017C20.486 22.0017 14.863 20.1349 14.863 17.8249C14.8632 17.0084 15.5867 16.261 16.7998 15.6078Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M24.5449 9.3552C26.948 9.16856 29.7257 9.86836 30.4261 11.6179C30.6594 12.2246 30.356 12.9021 29.7493 13.1355C29.1427 13.3688 28.4651 13.0654 28.2318 12.4587C28.0675 12.1786 26.6922 11.5716 24.7568 11.7113C22.7505 11.8746 21.7464 12.5984 21.6761 12.8552C22.0028 13.6485 24.5236 14.6984 27.7669 14.4184C30.2287 14.2197 31.9447 13.4779 32.7184 12.7732C32.7998 13.6366 32.9765 14.4722 33.2357 15.2706C31.908 16.0479 30.0789 16.5757 27.9538 16.7517C27.5806 16.7983 27.2064 16.7995 26.8099 16.7995H26.7871C23.6371 16.7995 20.2757 15.7715 19.459 13.6482C19.2026 12.9484 19.2739 12.2027 19.6937 11.5495C20.4402 10.3597 22.2588 9.54204 24.5449 9.3552Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M48.2993 13.952V10.0554L46.6427 11.012L44.916 12.7387V15.912L48.2993 13.952Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M43.7493 15.912V13.9054L42.466 15.1654L43.7493 15.912Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M40.366 13.952L40.3893 13.9754L42.8627 11.4787L40.366 10.0554V13.952Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M40.9493 9.0287L43.7027 10.6387L46.1993 8.16536L44.3327 7.09203L40.9493 9.0287Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M39.1993 14.6287V8.70203L44.3327 5.7387L47.0393 7.30203L50.026 4.31536C48.4393 3.0787 46.4793 2.33203 44.3327 2.33203C39.176 2.33203 34.9993 6.5087 34.9993 11.6654C34.9993 13.812 35.7693 15.772 36.9827 17.3587L39.526 14.8154L39.1993 14.6287Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M49.1393 8.5155L49.466 8.70217V14.6288L44.3327 17.5922L41.626 16.0288L38.6393 19.0155C40.226 20.2522 42.186 20.9988 44.3327 20.9988C49.4893 20.9988 53.666 16.8222 53.666 11.6655C53.666 9.51883 52.896 7.55883 51.6827 5.97217L49.1393 8.5155Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )
    case 'syrup_cinnamon_bun':
      return (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_458_3316)">
            <path
              d="M38.0343 34.1589C36.7276 35.4189 35.2343 36.8422 32.3176 36.8422C29.4009 36.8422 27.9076 35.4189 26.6009 34.1589C25.4109 33.0389 24.4776 32.1289 22.4943 32.1289C20.5109 32.1289 19.5776 33.0156 18.4109 34.1589C17.1043 35.4189 15.6109 36.8422 12.6943 36.8422C12.6009 36.8422 12.5309 36.8422 12.4609 36.8422C12.8809 39.1989 13.3243 40.8322 13.3243 40.8322C13.3243 43.4222 19.6476 45.5222 27.4409 45.5222C35.2343 45.5222 41.5576 43.4222 41.5576 40.8322C41.5576 40.8322 42.6309 36.8422 43.0509 32.2689C42.7709 32.2222 42.5143 32.1522 42.1643 32.1522C40.1809 32.1522 39.2476 33.0389 38.0576 34.1822L38.0343 34.1589Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M42.4446 21.5813C42.3746 21.138 41.8613 20.9747 41.5113 21.2313C38.478 23.3547 32.9246 24.358 27.418 24.358C21.9113 24.358 16.358 23.378 13.3246 21.2313C12.9513 20.9747 12.4613 21.138 12.3913 21.5813C12.018 23.728 11.668 26.4113 11.668 29.048C11.668 30.868 11.8313 32.7113 12.0646 34.3913C12.2746 34.4147 12.438 34.4614 12.6946 34.4614C14.678 34.4614 15.6113 33.5747 16.778 32.4313C18.0846 31.1713 19.578 29.748 22.4946 29.748C25.4113 29.748 26.9046 31.1713 28.2113 32.4313C29.4013 33.5513 30.3346 34.4614 32.318 34.4614C34.3013 34.4614 35.2346 33.5747 36.4246 32.4313C37.7313 31.1713 39.2246 29.748 42.1413 29.748C42.4913 29.748 42.8413 29.748 43.1446 29.818C43.1446 29.5613 43.1446 29.2813 43.1446 29.0247C43.1446 26.388 42.7946 23.6813 42.4213 21.5347L42.4446 21.5813Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M27.4205 22.0066C34.3505 22.0066 39.9739 20.1399 39.9739 17.8299C39.9739 17.0133 39.2505 16.2433 38.0372 15.6133C35.8439 18.4599 29.0072 18.6233 27.4205 18.6233C25.8339 18.6233 18.9972 18.4366 16.8039 15.6133C15.5905 16.2666 14.8672 17.0133 14.8672 17.8299C14.8672 20.1399 20.4905 22.0066 27.4205 22.0066Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M26.8124 16.7968C27.209 16.7968 27.5824 16.7968 27.9557 16.7502C31.339 16.4702 33.9757 15.3035 35.0257 13.6468C35.5624 12.8068 35.6557 11.8502 35.329 10.9635C35.0957 10.3568 34.419 10.0535 33.8124 10.2868C33.2057 10.5202 32.9024 11.1968 33.1357 11.8035C33.1824 11.9435 33.229 12.1302 33.0424 12.4102C32.529 13.2035 30.6624 14.1835 27.769 14.4168C24.5257 14.6968 22.0057 13.6468 21.679 12.8535C21.749 12.5968 22.7524 11.8735 24.759 11.7102C26.6957 11.5702 28.0724 12.1768 28.2357 12.4568C28.469 13.0635 29.1457 13.3668 29.7524 13.1335C30.359 12.9002 30.6624 12.2235 30.429 11.6168C29.729 9.86684 26.9524 9.16684 24.549 9.3535C22.2624 9.54017 20.4424 10.3568 19.6957 11.5468C19.2757 12.2002 19.2057 12.9468 19.4624 13.6468C20.279 15.7702 23.639 16.7968 26.789 16.7968H26.8124Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_458_3316">
              <rect
                width="31.5"
                height="36.1667"
                fill="white"
                transform="translate(11.668 9.33203)"
              />
            </clipPath>
          </defs>
        </svg>
      )

    default:
      return ''
  }
}

export default CustomisedDrinkIcons
